import { render, staticRenderFns } from "./GradingPlanUpdate.vue?vue&type=template&id=2d6ec1c0&"
import script from "./GradingPlanUpdate.vue?vue&type=script&lang=js&"
export * from "./GradingPlanUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports